export enum SortTypes {
  nameAsc = 'name_asc',
  nameDesc = 'name_desc',
  createdAt = 'created_at',
  updatedAt = 'updated_at',
}
